import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Page, Popup, Navbar, NavRight, Link, Block } from 'framework7-react';
import Footer from './Footer';
import II18 from '../translate/II18';
import { gae } from '../helpers/Analytics';
import ChangeLang from './ChangeLang';
import FocusTrap from '../helpers/FocusTrap';
import { setShowMainInfoPopUp } from '../../redux/actions/rootAction';

export default function MainInfoPopUp() {
  const dispatch = useDispatch();
  const opened = useSelector(state => Boolean(state.showMainInfoPopUp));
  const selectedLang = useSelector(state => state.selectedLang);
  const companyName = useSelector(state => state.companyName);
  const companyEmail = useSelector(state => state.companyEmail);
  const [trapActive, setTrapActive] = React.useState(false);

  const onClose = () => {
    gae('INFO_POP_UP', 'CLOSE');
    dispatch(setShowMainInfoPopUp(false));
  };

  return (
    <Popup
      id={'info_popup'}
      style={{ overflow: 'visible' }}
      className="info-popup"
      animate={!window.isDesktop}
      key={selectedLang}
      opened={opened}
      swipeToClose={false}
      closeByBackdropClick={false}
      closeOnEscape={false}
      onPopupOpen={() => gae('INFO_POP_UP', 'SHOW')}
      onPopupOpened={() => setTrapActive(true)}
      onPopupClosed={() => setTrapActive(false)}
    >
      <FocusTrap opened={trapActive} onClose={onClose}>
        <Page>
          <Navbar title={II18.get('title_information')}>
            <NavRight>
              <Link onClick={onClose}>
                <II18>title_close</II18>
              </Link>
            </NavRight>
          </Navbar>
          <Block>
            <p>
              {companyName && (
                <II18 html params={companyName}>
                  info_popup_docs_from
                </II18>
              )}

              {companyEmail && (
                <>
                  <II18 html params={[companyName]}>
                    info_popup_emailto_sender_1
                  </II18>
                  <Link
                    target={'_blank'}
                    external
                    href={'mailto: ' + companyEmail}
                  >
                    {companyEmail}
                  </Link>
                  <II18>info_popup_emailto_sender_2</II18>
                </>
              )}
            </p>
          </Block>

          <div style={{ borderTop: '1px solid #ddd' }}>
            <Block>
              <p>
                <II18>info_popup_message_part1</II18>
                <Link href="https://www.paperfly.io/" target="_blank" external>
                  Paperfly
                </Link>
                <II18>info_popup_message_part2</II18>
                <Link
                  href="https://www.youtube.com/watch?v=9aHIS79uwqQ"
                  target="_blank"
                  external
                >
                  Video
                </Link>{' '}
                <II18>info_popup_message_part3</II18>
              </p>
            </Block>
            <Footer showLinks={true} bigLogo={true} />
            <ChangeLang />
          </div>
        </Page>
      </FocusTrap>
    </Popup>
  );
}
